module.exports = __webpack_public_path__ + "static/media/right-caret-white-circle.6d728c83.svg";